import { Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Applicant } from '../models/applicant';
import { NavigationParameters } from '../models/navigationParameters';
import { WaitlistService } from '../services/waitlist.service';
import { GeneralInfo } from '../models/generalInfo';
import { Parameters } from '../models/parameters';
import { ApplicantService } from '../services/applicant.service';
import { PortalParameters } from '../models/portalParameters';
import { Waitlists } from '../models/waitlists';
import { WaitlistsExtended } from '../models/waitlistsExtended';
import { WaitlistPortalService } from '../services/waitlist-portal.service';
import { ApplicantProcess } from '../models/applicantProcess';
import { ApplicantStep } from '../models/applicantStep';
import { ApplicantForm } from '../models/applicantForm';
import { ConfirmationMessageService } from '../services/confirm-message.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PortalLookups } from '../models/portalLookups';
import { environment } from 'src/environments/environment';
import { PopupMessageService } from '../services/popup.message.service';



@Component({
    selector: 'applicant-dashboard',
    templateUrl: './applicant-dashboard.component.html' ,
    styleUrls: ['./applicant-dashboard.component.scss']
})

export class ApplicantDashboardComponent implements OnInit{
    applicant:Applicant = new Applicant();
    generalInfo: GeneralInfo | null = null;
    loggedIn:boolean = false;
    phoneNumber: string = '';
    noAddress:boolean = false;
    role:string = "";
    userEmail:string = "";
    isIE:boolean = false;
    params:Parameters = new Parameters();
    portalParams:PortalParameters = new PortalParameters();
    navigationParams:NavigationParameters = new NavigationParameters();
    familySize:number = 0;
    lastUpdatedDate:string = "";
    waitlistsExtended: WaitlistsExtended[] = [];
    applicantProcesses: ApplicantProcess[] =[];
    applicantSteps: ApplicantStep[] = [];
    applicantForms: ApplicantForm[] = [];
    outdated:boolean = false;
    applicationUpdateOutdateMonths:number = 0;
    applicationUpdateOutdateDays:number = 0;
    monthlyIncome:number = 0;
    isMobile:boolean = false;
    @ViewChild("content",{static:true}) content!: ElementRef;
    // @ViewChild("contentWLStatus",{static:true}) contentWLStatus:ElementRef;   
    contentTitle: string = "Contact";
    stateList:PortalLookups[] = [];
    cityList:PortalLookups[] = [];
    applicantStatuses:PortalLookups[] = [];
    formInvalid:boolean = false;
    infoTextTitle: string = "";
    infoTextDescription:string = "";
    updateParam:string = "";
    imgFolder: string = environment.imgFolder;

constructor(
    private spinnerService: NgxSpinnerService,
    private waitlistService:WaitlistService,
    private applicantService:ApplicantService,
    private waitlistPortalService:WaitlistPortalService,
    private router:Router,
    private confirmationService: ConfirmationMessageService,
    private popupMessageService:PopupMessageService,
    private modalService: NgbModal
) {
    this.isMobile = window.innerWidth < 768;
}


    ngOnInit(){

        this.spinnerService.show();
        this.navigationParams = JSON.parse(localStorage.getItem('navigationParams') ?? '{}');
        this.applicant = JSON.parse(localStorage.getItem('applicant') ?? '{}');
        this.loggedIn =  this.navigationParams.loggedIn;
        this.role =  this.navigationParams.userRole;
        this.userEmail = this.navigationParams.loginEmail;

        if (this.role.toUpperCase() == "REGISTEREDUSER" || !this.applicant)
        {
            this.spinnerService.hide();
            this.router.navigate(['/home']);
        }
        else
        {
            // this.applicant = JSON.parse(localStorage.getItem('applicant'));
            this.generalInfo = this.applicant ? this.applicant.generalInfo : null;
            this.familySize = this.applicant.familyMembers?.length + 1;
            this.phoneNumber = (this.generalInfo?.cellTel?.length ?? 0) > 0 && (this.generalInfo?.homeTel?.length ?? 0) > 0
                ? 'both'
                : (this.generalInfo?.cellTel?.length ?? 0) > 0
                    ? this.generalInfo!.cellTel!
                    : (this.generalInfo?.homeTel?.length ?? 0) > 0
                        ? this.generalInfo!.homeTel!
                        : "Add a phone number";
            this.monthlyIncome = this.applicant.incomeRent?.monthlyGross;



            this.noAddress = true;
            if (this.generalInfo && this.generalInfo.mailingAddress && this.generalInfo.mailingAddress.length > 0) this.noAddress = false;
            if (this.generalInfo && this.generalInfo.city && this.generalInfo.city.length > 0) this.noAddress = false;
            if (this.generalInfo && this.generalInfo.state && this.generalInfo.state.length > 0) this.noAddress = false;
            if (this.generalInfo && this.generalInfo.zipCode && this.generalInfo.zipCode.length > 0) this.noAddress = false;


            this.waitlistPortalService.getPortalLookups("ApplicationUpdateOutdateMonths").then((m) => {
                this.applicationUpdateOutdateMonths = +m[0].description;
            }).catch((error) => { this.spinnerService.hide(); });


            this.waitlistPortalService.getPortalLookups("ApplicationUpdateOutdateDays").then((d) => {
                this.applicationUpdateOutdateDays = +d[0].description;
            }).catch((error) => { this.spinnerService.hide(); });

            
            this.params.applicantCode = this.applicant.generalInfo.pCode;
            if (this.params.applicantCode.substring(0,1).toUpperCase() == 'P')
            {
                this.applicantService.getApplicantLastUpdatedDateAFF(this.params)
                .subscribe(data  => { 
                    if (data) 
                        this.lastUpdatedDate = data.lastUpdatedDate;
                });
            }
            else
            {
                this.applicantService.getApplicantLastUpdatedDateHCV(this.params)
                .subscribe(data  => { 
                    if (data) 
                        this.lastUpdatedDate = data.lastUpdatedDate;
                        this.outdated = this.isOutdated(this.lastUpdatedDate);
                });
            }

            this.waitlistPortalService.getPortalLookups("SacCity").then((data) => {
                this.cityList = data;
            }).catch((error) => { 
                this.spinnerService.hide(); 
            });    

            this.waitlistPortalService.getPortalLookups("states").then((data) => {
                this.stateList = data;
            }).catch((error) => { 
                this.spinnerService.hide(); 
            });

            this.waitlistPortalService.getPortalLookups("ApplicantStatus").then((data) => {
                this.applicantStatuses = data;
            }).catch((error) => { 
                this.spinnerService.hide(); 
            });

            
            this.portalParams.category = "Waiting Lists";
            this.waitlistService.getWaitlistsByWLTypeCategory(this.portalParams)
            .subscribe(d=>{
                this.setupWaitlists(d);
            })

            if (this.outdated)
                this.showContactInfo("application");

            this.spinnerService.hide();
        }
        
    }
   

    popupClick(infoText:string){
        const status = this.applicantStatuses.find(s => s.description.substring(0, 12).includes(infoText));
        const statusDescription = status?.description?.replace(infoText + "-", "") ?? "";
        this.popupMessageService.show("Waiting List Status - " + infoText, statusDescription, true, "md");
    }


    isOutdated(dt:string):boolean{
            let month = Number(dt.slice(0, 2));
            let day = Number(dt.slice(3, 5));
            let year = Number(dt.slice(6,10));

            let dtOutdate = new Date(year, month + this.applicationUpdateOutdateMonths, day + this.applicationUpdateOutdateDays);
            let dtToday = new Date(Date.now());

            if (dtOutdate < dtToday)
                return true;
            
            return false;
    }

    goToPropertyProfile(w:WaitlistsExtended){
            localStorage.setItem('waitlistExtended', JSON.stringify(w));
            this.router.navigate(['/property']);
    }

    goToForm(processID:string,formID:string, applicantFormID:string, formTitle:string, tCode:string){
        localStorage.setItem('tcode', JSON.stringify(tCode));
        localStorage.setItem('FormID', JSON.stringify(formID));
        localStorage.setItem('applicantFormID', JSON.stringify(applicantFormID));
        localStorage.setItem('ProcessID', JSON.stringify(processID));
        localStorage.setItem('isapplicantFormLocked', JSON.stringify('false'));
        localStorage.setItem('FormTitle', JSON.stringify(formTitle));
        this.router.navigate(['/form']);
    }
  

    updateApplication(){

        if (!this.loggedIn) 
        {
            localStorage.clear();
            this.router.navigate(['/loginMain']);
        }

        this.applicant = JSON.parse(localStorage.getItem('applicant') ?? '{}') ?? new Applicant();
        this.navigationParams.returnLocation = "applicantDashboard";

        if (this.role.toUpperCase() != 'STAFF' && 
            (!this.navigationParams.affPCode || this.navigationParams.affPCode?.length == 0) 
            && (this.applicant.generalInfo.tenantStatus.toUpperCase() == 'CURRENT' || this.applicant.generalInfo.tenantStatus.toUpperCase() == 'NOTICE'))
        {
            this.confirmationService.confirm('Application Update','Hello! Your Housing Choice Voucher or Public Housing application update cannot be completed in this Waitlist Portal because you are a participant in current status or in a move process.  Please submit your Change of Household (COH) or Change of Income (COI) on the <a href="https://portal.shra.us/residentportal/#/login" target="blank">Resident Portal</a>', 'OK', true)
            .then(result => { });
        }
        else
        {
            if (this.navigationParams.affPCode?.length > 0 && (this.applicant.generalInfo.tenantStatus.toUpperCase() == 'CURRENT' || this.applicant.generalInfo.tenantStatus.toUpperCase() == 'NOTICE'))
                this.navigationParams.resultMessage = 'Hello! Your Affordable Housing application has been updated. Your Housing Choice Voucher or Public Housing application update cannot be completed in this Waitlist Portal because you are a participant in current status or in a move process.  Please submit your Change of Household (COH) or Change of Income (COI) on the <a href="https://portal.shra.us/residentportal/#/login" target="blank">Resident Portal</a>';
            else
                this.navigationParams.resultMessage = "Hello!  Your application has been updated.";

            localStorage.setItem('navigationParams', JSON.stringify(this.navigationParams));
            this.router.navigate(['/generalInfo']);
        }
        // localStorage.setItem('navigationParams', JSON.stringify(this.navigationParams));
    }  


    showContactInfo(updateParam:string){

        this.updateParam = updateParam;
        let size:string = updateParam == "contact" ? "lg" : 'md';
        this.contentTitle = updateParam == "contact" ? "Contact Information" : updateParam;

        if (this.applicant.generalInfo.tenantStatus.toUpperCase() == 'CURRENT' || this.applicant.generalInfo.tenantStatus.toUpperCase() == 'NOTICE')
        {
            this.confirmationService.confirm('Contact Information Update','Hello! Your contact information update cannot be completed in this Waitlist Portal because you are a participant in current status or in a move process.  Please submit your Change of Household (COH) or Change of Income (COI) on the <a href="https://portal.shra.us/residentportal/#/login" target="blank">Resident Portal</a>', 'OK', true)
            .then(result => { });
        }
        else
            this.modalService.open(this.content, { size: size, centered: true});
    }


    applyWaitlist(){
        this.router.navigate(['/waitingList']);
    }

    setupWaitlists(wls:Waitlists[]){
        wls.forEach ((wl) =>
        {
            let wle: WaitlistsExtended = new WaitlistsExtended;
            wle.waitlistExtendedName = wl.name;
            wle.waitlist = wl;
            this.portalParams.waitlist = wl.name;
            this.portalParams.waitlistProgram = wl.yardiDB.toUpperCase() == "AFF" ? "Affordable Housing" : wl.yardiDB.toUpperCase() == "CNV" ? "Public Housing" : "Housing Choice Voucher";
            this.waitlistPortalService.getApplicantWaitlistStatus(this.portalParams).then(h =>{
                if (h && h.waitlistStatus != "Not On List" && h.waitlistStatus != "Not Placed on List")
                {
                    wle.applicantStatus = h.waitlistStatus;
                    wle.applicantBedroom = h.bedroomSize;
                    this.waitlistsExtended.push(wle); 
                }
            });
        });
    }

}